import { safeParse } from "../helper/helper";

export const hydrateFromSession = () => {
  const user = safeParse(sessionStorage.getItem("user"));
  const menus = safeParse(sessionStorage.getItem("menus"));
  const loggedIn = safeParse(sessionStorage.getItem("loggedIn"));

  return {
    user,
    menus,
    loggedIn,
  };
};
